import React from 'react';
import PropTypes from 'prop-types';
import formatMoney from 'utils/formatters/Money';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import { BadgeAlt as Badge, Table, TableHeader, TableHead, TableRow, TableBody, TableCell, } from '@cargomatic/ui';
const STATUS_BADGE_CLASSES = {
    succeeded: 'bg-green-100 text-green-800',
    failed: 'bg-red-100 text-red-800',
    pending: 'bg-yellow-100 text-yellow-800',
};
const PaymentHistory = ({ payments = [], currency }) => {
    const { t } = useTranslation();
    if (payments.length === 0) {
        return (React.createElement("p", { "data-testid": "p-25cd168f", className: "py-3 my-0 text-sm text-muted-foreground" }, t('THERE_ARE_NO_PAYMENTS')));
    }
    return (React.createElement("div", { "data-testid": "div-acdf1b3a", className: "overflow-x-auto" },
        React.createElement(Table, { "data-testid": "table-3fa43e0e" },
            React.createElement(TableHeader, { "data-testid": "thead-9e124809" },
                React.createElement(TableRow, { "data-testid": "tr-4faf90fd" },
                    React.createElement(TableHead, { "data-testid": "th-2d6ae998" }, t('DATE', { count: 1 })),
                    React.createElement(TableHead, { "data-testid": "th-cfb398d2" }, t('AMOUNT')),
                    React.createElement(TableHead, { "data-testid": "th-f7b26767" }, t('TYPE')),
                    React.createElement(TableHead, { "data-testid": "th-fca83df7" },
                        t('TRANSACTION_CHECK'),
                        " #"),
                    React.createElement(TableHead, { "data-testid": "th-c3a17070" }, t('STATUS')))),
            React.createElement(TableBody, { "data-testid": "tbody-a2dea422" }, payments.map((payment, i) => {
                var _a, _b, _c, _d, _e;
                let paymentSource = t('AUTOMATIC');
                const date = moment(payment.date).format('L');
                if (payment.description && payment.description.type) {
                    paymentSource = t('MANUAL');
                    if (payment.description.type === 'check')
                        paymentSource = t('CHECK');
                }
                const paymentNumber = ((_a = payment.description) === null || _a === void 0 ? void 0 : _a.type) === 'check'
                    ? (_b = payment.description) === null || _b === void 0 ? void 0 : _b.check_number
                    : (_c = payment.description) === null || _c === void 0 ? void 0 : _c.transaction_id;
                const status = (_d = payment.description) === null || _d === void 0 ? void 0 : _d.status;
                const transaction_date = (_e = payment.description) === null || _e === void 0 ? void 0 : _e.transaction_date;
                const transactionDate = transaction_date
                    ? moment(transaction_date).format('L')
                    : null;
                const key = payment._id || paymentNumber || `${payment.date}-${i}`;
                return (React.createElement(TableRow, { "data-testid": `tr-783e852a-${i}`, key: key },
                    React.createElement(TableCell, { "data-testid": `td-4abccdfc-${i}` }, transactionDate || date),
                    React.createElement(TableCell, { "data-testid": `td-33f2f45c-${i}` }, formatMoney(payment.amount, currency)),
                    React.createElement(TableCell, { "data-testid": `td-80b2735a-${i}` }, paymentSource),
                    React.createElement(TableCell, { "data-testid": `td-6f7712b1-${i}` }, paymentNumber),
                    React.createElement(TableCell, { "data-testid": `td-9b20721e-${i}` }, status && (React.createElement(Badge, { "data-testid": `span-999d1703-${i}`, className: STATUS_BADGE_CLASSES[status] || '' }, t(sluggify(status)))))));
            })))));
};
PaymentHistory.propTypes = {
    payments: PropTypes.array,
    currency: PropTypes.string,
};
export default PaymentHistory;
